// correct url format: http:// + location.domain + /game/ + network-txn
export const getRoomId = (inviteLink: string) => {
  const arr = inviteLink.split("/");
  if (arr.length !== 5) {
    throw new Error("Invalid link");
  }
  const [protocol, , domain, path, gameId] = arr;
  if (protocol !== window.location.protocol) {
    throw new Error("Invalid protocol");
  }
  if (domain !== window.location.host) {
    throw new Error("Invalid domain");
  }
  // TODO: check domain validity
  if (path !== "game") {
    throw new Error("Invalid path");
  }
  const gameArr = gameId.split("-");
  if (gameArr.length !== 2) {
    throw new Error("Invalid parameters");
  }
  return gameArr;
};
